<template>
  <section
    class=" layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row y-gap-30 justify-between">
        
        <div class="col-lg-6 order-1 order-lg-2">
          <div class="test">
            <img
              :src="vars.photoImage"
            />
          </div>
        </div>
        
       
        <div class="col-xl-5 col-lg-6 order-2 order-lg-1">
          <h6
  v-if="vars.altTitleText"
  style="color: var(--c-secondary) !important;"
>
  {{ vars.altTitleText }}
        </h6>
          <div> <h2> {{ vars.titleText }}</h2></div>
          <div class="accordion -simple row y-gap-20 pt-60 lg:pt-30 js-accordion">
            <div class="col-12" v-for="(accordion, index) in accordions" :key="index">
              <div class="accordion__item pt-15">
                <div class="accordion__button pb-15 d-flex items-center">
                  <div class="button text-18 md:text-16 uppercase fw-500 text-dark-1">
                    {{ accordion.title }}
                  </div>
                  <div class="accordion__icon size-40 flex-center bg-light-2 rounded-full mr-20">
                    <i class="icon-plus"></i>
                    <i class="icon-minus-1"></i>
                  </div>
                </div>
                <div class="accordion__content">
                  <div class="pt-15 ">
                    <p>{{ accordion.content }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TeamSection',

  mixins: [ComponentMixin],

  computed: {
    
   
   
    accordions() {
      return this.groupedVariables.accordions ;
    },
  },
});
</script>
